<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer title="File Setting Options" @hide="cancelAddModal()" @show="setData">
    <div class="d-block uploadCdnImageWrapper">
      <template v-if="selectedOption === ''">
        <div class="imageSettingOptionWrapper">
          <template v-if="parentIdx !== -1">
            <b-button variant="primary" @click="selectedOption = 'change-folder'">Change Folder</b-button>
          </template>
          <template v-if="showUpdateOption">
            <b-button variant="primary" @click="selectedOption = 'update-image'">Update Image</b-button>
          </template>
        </div>
      </template>
      <template v-else>
        <b-row>
          <b-col sm="12" v-if="show">
            <template v-if="selectedOption === 'change-folder'">
              <h4>Change Folder for file</h4>
              <hr class="m-1">
              <b-row>
                <b-col sm="5">
                  <treeselect :options="folderList" v-model="activefolder" :normalizer="normalizer" :max-height="1000" isDefaultExpanded :default-expand-level="1" class="folderWrapper" always-open >
                    <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                      <i class='fa fa-folder-o mr-2'></i> {{ node.label }}
                    </label>
                  </treeselect>
                </b-col>
                <b-col sm="7">
                  <img :src="selectedImage.ImgUrl" alt="">
                </b-col>
                <b-col sm="12" class="mt-2 text-right">
                  <b-button variant="success" @click="changeFolder()" :disabled="activefolder === parentIdx">Change Folder</b-button>
                  <b-button variant="outline-danger" @click="selectedOption = ''">Back</b-button>
                </b-col>
              </b-row>
            </template>
            <template v-else>
              <h4>Upload New Image</h4>
              <hr class="m-1">
              <b-col sm="6">
                <p-image v-model="form.image" :name="`image`" :handler="$v" :formData="form" />
              </b-col>
              <b-col sm="12" class="mt-2 text-right">
                <b-button variant="success" @click="updateImage()" :disabled="processingUpdate">Update</b-button>
                <b-button variant="outline-danger" @click="selectedOption = ''">Back</b-button>
              </b-col>
            </template>
          </b-col>
        </b-row>
      </template>
    </div>
  </b-modal>
</template>

<script>

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { Events } from '../../events.js'
import VueNotifications from 'vue-notifications'
import { PImage } from '../../components'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    showAddModal: {
      type: Boolean,
      default: false
    },
    parentIdx: {
      type: [ Number, String ],
      default: ''
    },
    folderList: {
      type: Array,
      default: function () { return [] }
    },
    selectedImage: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: () => {
    return {
      activefolder: '',
      selectedOption: '',
      processingUpdate: false,
      form: {
        image: '',
        errorMessages: {
          image: {
            required: 'Image is required'
          }
        }
      }
    }
  },
  validations: {
    form: {
      image: {
        required
      }
    }
  },
  components: {
    Treeselect,
    PImage
  },
  computed: {
    show: {
      get: function () {
        return this.showAddModal
      },
      set: function () {
        return this.showAddModal
      }
    },
    showUpdateOption: function () {
      if (Object.keys(this.selectedImage).length > 0) {
        if (this.selectedImage.Category.includes('tournament')) {
          return false
        }
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    setData () {
      this.form.image = this.selectedImage.ImgUrl
    },
    normalizer (node) {
      return {
        id: node.Id,
        label: node.Name,
        children: node.children
      }
    },
    async changeFolder () {
      try {
        const payload = {
          imageId: this.selectedImage.Id,
          folderId: this.activefolder
        }
        await this.$http.post(`${this.API_ENDPOINT}/fileManager/image/updateFolder`, payload, { headers: { 'Content-Type': 'application/json' } })
        this.$emit('loadUpdatedData')
        this.cancelAddModal()
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Folders Updated Successfully.')
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    async updateImage () {
      try {
        this.$v.form.$touch()
        if (this.$v.form.$error) {
          return true
        } else {
          let formData = new FormData()
          const ImageId = this.selectedImage.Id
          formData.append('Image', this.form.image)
          await this.$http.post(`${this.API_ENDPOINT}/fileManager/image/updateImage?ImageId=${ImageId}`, formData, { headers: { 'Content-Type': 'application/json' } })
          this.$emit('loadUpdatedData')
          this.cancelAddModal()
          Events.$emit('alert', VueNotifications.types.success, 'Success', 'Image Updated Successfully.')
        }
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      }
    },
    cancelAddModal () {
      this.activefolder = ''
      this.form.image = ''
      this.selectedOption = ''
      this.$emit('cancelAddFolderModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/cdnFileManager/FileSettingModal.vue